import { useEffect, useState } from "react";
import { SITE } from "@/config/site";

const KEY = "pic_cookies";

const loadTrackers = () => {
  if (SITE.googleAnalyticsId && !window.gtag) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${SITE.googleAnalyticsId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", SITE.googleAnalyticsId);
  }
  if (SITE.metaPixelId && !window.fbq) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", SITE.metaPixelId);
    window.fbq("track", "PageView");
  }
};

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  useEffect(() => { if (choice === "si") loadTrackers(); }, [choice]);
  const decide = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  if (choice) return null;

  return (
    <div role="dialog" aria-label="Aviso de cookies" data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-2xl rounded-2xl border border-[#E3EAEF] bg-white p-5 shadow-[0_20px_50px_-15px_rgba(11,60,93,.35)] sm:bottom-5">
      <p className="text-[16px] leading-relaxed text-[#1F2A33]">
        Usamos cookies para que el sitio funcione y, si lo aceptas, para medir visitas. <a href="/privacidad" className="font-semibold text-[#0B3C5D] underline">Más información</a>.
      </p>
      <div className="mt-4 flex gap-3">
        <button onClick={() => decide("si")} data-testid="cookie-accept" className="min-h-[48px] flex-1 rounded-xl bg-[#0B3C5D] px-5 text-[16px] font-bold text-white focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#1FA89A]">Aceptar</button>
        <button onClick={() => decide("no")} data-testid="cookie-reject" className="min-h-[48px] flex-1 rounded-xl border-2 border-[#0B3C5D] px-5 text-[16px] font-bold text-[#0B3C5D] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#1FA89A]">Solo necesarias</button>
      </div>
    </div>
  );
};
